interface TruncateProps {
  text: string
  maxLength?: number
}

export const MultilineTruncate: React.FC<TruncateProps> = ({
  text,
  maxLength = 200,
}) => {
  const truncatedText =
    text.length > maxLength ? `${text.substring(0, maxLength)}...` : text
  return <span>{truncatedText}</span>
}
